import { render, staticRenderFns } from "./EditableContent.vue?vue&type=template&id=5e96e9c0&scoped=true&"
import script from "./EditableContent.vue?vue&type=script&lang=js&"
export * from "./EditableContent.vue?vue&type=script&lang=js&"
import style0 from "./EditableContent.vue?vue&type=style&index=0&id=5e96e9c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e96e9c0",
  null
  
)

export default component.exports